const text = (value) => String(value || "").replace(/\s+/g, " ").trim();
const personProfile = /^(https?:\/\/)?([a-z0-9-]+\.)?linkedin\.com\/(in|pub)\//i;
const comparable = (value) => text(value).toLowerCase();

// A scraped LinkedIn page title identifies the person, not their job. Keep the
// original record intact and choose a role only for the company table label.
export function getCompanyLeadTitle(row = {}) {
  const names = [row.contact_name, row.contactName, row.full_name]
    .map(comparable).filter(Boolean);
  const fromProfile = personProfile.test(text(row.lead_link));
  const candidates = [
    row.linked_job_title, row.job?.job_title,
    row.job_title, row.jobTitle, row.position_title, row.role_title,
    row.contact_title, row.contact_role,
  ];
  return candidates.map(text).find((title) => title &&
    !names.includes(comparable(title)) &&
    !(fromProfile && /\|\s*linkedin\s*$/i.test(title))) || "Lead";
}
